import * as React from 'react';
import { Basic } from '../../components/Basic';
import { Call } from '../Call/Call';
import { BasicCallbackButton } from '../CallbackButton';
import { LabelsContainer } from '../Labels';
import { MessageButtonContainer } from '../MessageButton';
import { NewbuildingNameContainer } from '../NewbuildingName';
import { PriceContainer } from '../Price';

export function BasicContainer() {
  return (
    <Basic
      name={<NewbuildingNameContainer />}
      price={<PriceContainer />}
      callback={<BasicCallbackButton buttonSize="L" />}
      call={<Call buttonSize="L" />}
      labels={<LabelsContainer />}
      messageButton={<MessageButtonContainer buttonSize="L" />}
    />
  );
}
